import { SECTIONS, type AudienceSection as Doc, type PortalConfig } from '@sonder/shared'
import { useSectionEditor } from '@/data/editor'
import { EntityCard, NoEntities, useBrands } from './common'
import { FieldEditor } from './FieldEditor'

const DEF = SECTIONS.audience

export function AudienceSection({ clientId }: { clientId: string; config: PortalConfig }) {
  const ed = useSectionEditor<Doc>(clientId, 'audience')
  const brands = useBrands(clientId)
  if (!ed.doc) return null
  if (brands.order.length === 0) return <NoEntities what="brands" hint="Audience profiles are per brand; add brands first." />
  return (
    <div className="grid gap-12">
      {brands.order.map((id) => (
        <EntityCard key={id} eyebrow="Audience" title={brands.name(id)}>
          {DEF.fields.map((f) => (
            <FieldEditor key={f.key} editor={ed} path={`items.${id}.${f.key}`} def={f} />
          ))}
        </EntityCard>
      ))}
    </div>
  )
}
